import { render, staticRenderFns } from "./ShowFieldContract.vue?vue&type=template&id=b4160c78&scoped=true&"
import script from "./ShowFieldContract.vue?vue&type=script&lang=js&"
export * from "./ShowFieldContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4160c78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VMain,VSimpleTable})
